import styled from '@emotion/styled';

export const PageDetailsContentWrapper = styled.div`
  margin: 2rem 2.5rem;
`;
